/* eslint-disable import/no-extraneous-dependencies, global-require */

import { createStore, applyMiddleware, compose } from 'redux';
// import {persistState} from 'redux-devtools';
import { persistStore } from 'redux-persist';

// import promiseMiddleware from 'redux-promise';
import ReduxThunk from 'redux-thunk';
// import createLogger from 'redux-logger';

// import DevTools from '../DevTools';

import createSagaMiddleware from 'redux-saga';

import adminSagas from 'app/ducks/admins/sagas';
import authenticationSagas from 'app/ducks/authentication/sagas';
import bankAccountsSagas from 'app/ducks/bankAccounts/sagas';
import bulkImportsSagas from 'app/ducks/bulkImports/sagas';
import competitionsSagas from 'app/ducks/competitions/sagas';
import connectionsSagas from 'app/ducks/connections/sagas';
import connectionRunsSagas from 'app/ducks/connectionRuns/sagas';
import connectionTypesSagas from 'app/ducks/connectionTypes/sagas';
import creditCardsSagas from 'app/ducks/creditCards/sagas';
import dataImportSagas from 'app/ducks/dataImports/sagas';
import fixtureMatchesSagas from 'app/ducks/fixtureMatches/sagas';
import fixtureMatchImportsSagas from 'app/ducks/fixtureMatchImports/sagas';
import forfeitsSagas from 'app/ducks/forfeits/sagas';
import globalSagas from 'app/ducks/global/sagas';
import groupImportsSagas from 'app/ducks/groupImports/sagas';
import groupsSagas from 'app/ducks/groups/sagas';
import invitationsSagas from 'app/ducks/invitations/sagas';
import matchPaymentsSagas from 'app/ducks/matchPayments/sagas';
import refundsSagas from 'app/ducks/refunds/sagas';
import onBoardingSagas from 'app/ducks/onboarding/sagas';
import orgCustomersSagas from 'app/ducks/orgCustomers/sagas';
import orgTeamsSagas from 'app/ducks/orgTeams/sagas';
import organisationAddressesSagas from 'app/ducks/organisationAddresses/sagas';
import organisationSectionsSagas from 'app/ducks/organisationSections/sagas';
import organisationsSagas from 'app/ducks/organisations/sagas';
import organisationFeesSagas from 'app/ducks/organisationFees/sagas';
import organisationTagsSagas from 'app/ducks/organisationTags/sagas';
import notificationConfigsSagas from 'app/ducks/notificationConfigs/sagas';
import paymentCollectionsSagas from 'app/ducks/paymentCollections/sagas';
import paymentEventImportsSagas from 'app/ducks/paymentEventImports/sagas';
import paymentEventsSagas from 'app/ducks/paymentEvents/sagas';
import paymentRecordsSagas from 'app/ducks/paymentRecords/sagas';
import paymentRequestsSagas from 'app/ducks/paymentRequests/sagas';
import paymentsSagas from 'app/ducks/payments/sagas';
import paymentTagsSagas from 'app/ducks/paymentTags/sagas';
import peopleSagas from 'app/ducks/people/sagas';
import purchasesSagas from 'app/ducks/purchases/sagas';
import receiptsSagas from 'app/ducks/receipts/sagas';
import remindersSagas from 'app/ducks/reminders/sagas';
import reportsSagas from 'app/ducks/reports/sagas';
import subscriptionPaymentsSagas from 'app/ducks/subscriptionPayments/sagas';
import stripeSessionsSagas from 'app/ducks/stripeSessions/sagas';
import organisationProductsSagas from 'app/ducks/organisationProducts/sagas';
import organisationSubscriptionsSagas from 'app/ducks/organisationSubscriptions/sagas';
import rootReducer from '../reducer';

const sagaMiddleware = createSagaMiddleware();

/**
 * Entirely optional.
 * This tiny library adds some functionality to your DevTools,
 * by logging actions/state to your console. Used in conjunction
 * with your standard DevTools monitor gives you great flexibility.
 */
// const logger = createLogger({level:'info', collapsed:true});

// const middlewares = [
//   ReduxThunk, logger, require('redux-immutable-state-invariant')()
// ];

const middlewares = [
  ReduxThunk,
  require('redux-immutable-state-invariant').default(),
  sagaMiddleware,
];

// By default we try to read the key from ?debug_session=<key> in the address bar
// const getDebugSessionKey = function() {
//   const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
//   return (matches && matches.length)
//     ? matches[1]
//     : null;
// };

const enhancer = compose(applyMiddleware(...middlewares));

export default function configureStore(initialState) {
  const store = createStore(rootReducer, initialState, enhancer);
  const persistor = persistStore(store);

  sagaMiddleware.run(adminSagas);
  sagaMiddleware.run(authenticationSagas);
  sagaMiddleware.run(bankAccountsSagas);
  sagaMiddleware.run(bulkImportsSagas);
  sagaMiddleware.run(competitionsSagas);
  sagaMiddleware.run(connectionsSagas);
  sagaMiddleware.run(connectionRunsSagas);
  sagaMiddleware.run(connectionTypesSagas);
  sagaMiddleware.run(creditCardsSagas);
  sagaMiddleware.run(dataImportSagas);
  sagaMiddleware.run(fixtureMatchesSagas);
  sagaMiddleware.run(fixtureMatchImportsSagas);
  sagaMiddleware.run(forfeitsSagas);
  sagaMiddleware.run(globalSagas);
  sagaMiddleware.run(groupImportsSagas);
  sagaMiddleware.run(groupsSagas);
  sagaMiddleware.run(invitationsSagas);
  sagaMiddleware.run(matchPaymentsSagas);
  sagaMiddleware.run(refundsSagas);
  sagaMiddleware.run(onBoardingSagas);
  sagaMiddleware.run(orgCustomersSagas);
  sagaMiddleware.run(orgTeamsSagas);
  sagaMiddleware.run(organisationAddressesSagas);
  sagaMiddleware.run(organisationSectionsSagas);
  sagaMiddleware.run(organisationsSagas);
  sagaMiddleware.run(organisationFeesSagas);
  sagaMiddleware.run(organisationTagsSagas);
  sagaMiddleware.run(notificationConfigsSagas);
  sagaMiddleware.run(paymentCollectionsSagas);
  sagaMiddleware.run(paymentEventImportsSagas);
  sagaMiddleware.run(paymentEventsSagas);
  sagaMiddleware.run(paymentRecordsSagas);
  sagaMiddleware.run(paymentRequestsSagas);
  sagaMiddleware.run(paymentsSagas);
  sagaMiddleware.run(paymentTagsSagas);
  sagaMiddleware.run(peopleSagas);
  sagaMiddleware.run(purchasesSagas);
  sagaMiddleware.run(receiptsSagas);
  sagaMiddleware.run(reportsSagas);
  sagaMiddleware.run(remindersSagas);
  sagaMiddleware.run(subscriptionPaymentsSagas);
  sagaMiddleware.run(stripeSessionsSagas);
  sagaMiddleware.run(organisationProductsSagas);
  sagaMiddleware.run(organisationSubscriptionsSagas);

  return { persistor, store };
}
